<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {computed, onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import axios from "axios";
import {useHead} from "@vueuse/head";

const router = useRouter();
const route = useRoute();
const datalist = ref(null)
const Keywords = ref()
const current = ref(1)

const lastPage = computed(() => {
  return Math.ceil(datalist.value.count / 12)
})

const prevPage = computed(() => {
  if (current.value > 1) {
    return current.value - 1;
  } else {
    return 1
  }
})

const nextPage = computed(() => {
  if (current.value < lastPage.value) {
    return current.value + 1;
  } else {
    return current.value
  }
})

const pages = computed(() => {
      const pages = []
      for (let i = 1; i <= lastPage.value; i++) {
        if (i === current.value || i === lastPage.value || (i >= current.value - 1 && i <= lastPage.value + 1)) {
          pages.push(i)
        } else if (pages[pages.length - 1] !== '...') {
          pages.push('...')
        }
      }
      return pages
    }
)

function get_Blogs() {
  let url = '/api/blogs/'
  const page = Number(route.query.page)
  const title = route.query.title
  const tag = route.query.tag
  const param = new URLSearchParams()

  if (page) {
    param.append('page', page)
  }
  if (title) {
    param.append('title', title)
  }
  if (tag) {
    param.append('category_id_category', tag)
  }
  url = url + '?' + param.toString();
  axios
      .get(url)
      .then(response => {
        datalist.value = response.data
      })
      .catch(error => {
        console.log(error)
      });
}

function getPageFromUrl() {
  const page = Number(route.query.page);
  return page ? page : 1
}

function getToPage(page) {
  current.value = page
  const query = {...route.query}
  query.page = page
  router.push({query})
}

function getSearch() {
  const search = Keywords.value.trim()
  router.push({
    query: {title: search}
  })
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}

onMounted(() => {
  const scripts = [
    '/static/js/jquery-3.6.0.min.js',
    '/static/js/bootstrap.min.js',
    '/static/js/popper.min.js',
    '/static/js/magnific-popup.min.js',
    '/static/js/slick.min.js',
    '/static/js/counterup.min.js',
    '/static/js/waypoints.min.js',
    '/static/js/jquery-ui-min.js',
    '/static/js/jquery.nice-select.min.js',
    '/static/js/theia-sticky-sidebar.min.js',
    '/static/js/main1.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);

  current.value = getPageFromUrl()
  get_Blogs()
})

watch(() => route.query,
    () => {
      get_Blogs()
    }, {immediate: true}
)

useHead({
  title: 'Aluminum Window Exporter',
  meta: [
    {
      name: 'keywords',
      content: 'Aluminum Window Exporter'
    },
    {
      name: 'description',
      content: 'Upgrade your home with stunning aluminum windows for a touch of class.'
    }
  ]
})

</script>

<template>
  <Header/>
  <div class="lt-breadcrumb">
    <div class="breadcrumb-content">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="title">
            <h1>Blog Grid With Sidebar</h1>
          </div>
          <ol class="breadcrumb align-self-center">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Blog Grid</li>
          </ol>
        </div>
      </div><!-- /.container -->
    </div><!-- /.breadcrumb-content -->
  </div><!-- /.lt-breadcrumb -->

  <div class="lt-page-content bg-color">
    <div class="lt-section">
      <div class="section-content section-padding">
        <div class="container">
          <div class="lt-filter-form list-view-tab">
            <div class="lt-filter-form-content">
              <div class="lt-filter-form">
                <form action="#">
                  <div class="form-content">
                    <div class="search-content">
                      <input v-model="Keywords" class="form-control" name="search" type="text"
                             placeholder="Search here..">
                      <button v-on:click.prevent="getSearch" type="submit"><i class="fa fa-search"></i></button>
                    </div>
                  </div><!-- /.row -->
                </form>
              </div>

              <div class="lt-filter d-flex justify-content-between">
                <div class="left-content d-flex">
                  <ul class="property-tabs global-list d-flex align-self-center">
                    <li class="grid-view-tab active"><i class="fa fa-th-large" aria-hidden="true"></i></li>
                    <li class="list-view-tab"><i class="fa fa-list" aria-hidden="true"></i></li>
                  </ul>
                </div>
              </div>
            </div><!-- /.lt-filter-content -->

            <div class="row">
              <div class="col-md-7 col-lg-8 lt-sticky">
                <div class="theiaStickySidebar">
                  <div class="row">
                    <div v-if="datalist && datalist.results" v-for="list in datalist.results" :key="list.id"
                         class="col-md-4">
                      <div class="property">
                        <div class="thumb">
                          <img :src="list.image" alt="Image" class="img-fluid">
                          <div class="overlay">
                            <div class="icons">
                              <ul class="global-list">
                                <li><a :href="'/blogs/' + list.title"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                </li>
                                <li><a :href="list.image" class="lt-popup"><i class="fa fa-search"
                                                                              aria-hidden="true"></i></a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="property-info">
                          <div class="info-top">
                            <h2><a :href="'/blogs/' + list.site">{{ list.title }}</a></h2>
                          </div>
                          <div class="property-footer d-flex justify-content-between">
                            <div class="price align-self-center">
                              <h3>{{ formatDate(list.updated_at) }}</h3>
                            </div>
                          </div><!-- /.property-footer -->
                        </div><!-- /.property-info -->
                      </div><!-- /.property -->
                    </div>

                  </div><!-- /.row -->
                  <div class="lt-pagination">
                    <ul v-if="datalist && datalist.results" v-for="page in pages" :key="page" class="pagination ">
                      <li><a @click="getToPage(prevPage)" class="page-numbers" href="#"><i
                          class="fa fa-chevron-left"></i></a></li>
                      <li><a v-if="page === current.value" @click="getToPage(page)" class="page-numbers"
                             href="#">{{ page }}</a>
                        <a v-else-if="page === '...'" @click="getToPage(page)" class="page-numbers" href="#">{{
                            page
                          }}</a>
                        <a v-else @click="getToPage(page)" class="page-numbers" href="#">{{ page }}</a>
                      </li>
                      <li><a @click="getToPage(nextPage)" class="page-numbers" href="#"><i
                          class="fa fa-chevron-right"></i></a></li>
                    </ul>
                  </div><!-- /.lt-pagination -->
                </div>
              </div>
            </div><!-- /.row -->
          </div><!-- /.lt-filter-form -->
        </div><!-- /.container -->
      </div><!-- /.section-content -->
    </div><!-- /.lt-section -->
  </div><!-- /.lt-page-content -->


  <Footer/>
</template>

<style scoped lang="scss">

</style>